import gsap from 'gsap';
import { CustomEase } from 'gsap/CustomEase';
gsap.registerPlugin(CustomEase);

import Swiper, {
	EffectFade,
	Navigation,
	Keyboard,
	HashNavigation,
} from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';

export default {
	init() {
		console.log('overview');

		var isLoaded = false;

		jQuery(document).ready(function ($) {
			var $body = $('body'),
				$header = $('.main_header'),
				$main = $('main');

			window.addEventListener('load', function () {
				isLoaded = true;
				showElements();
			});

			setTimeout(function () {
				if (!isLoaded) {
					showElements();
				}
			}, 1000);

			function showElements() {
				$body.removeClass('intro--off');
				gsap.to([$header, $main], {
					y: '0',
					delay: 1,
					duration: 1,
					ease: CustomEase.create('custom', '0.47, 0, 0.03, 1'),
				});
			}

			const swiperProjects = new Swiper('.project_swiper', {
				modules: [EffectFade, Navigation, Keyboard, HashNavigation],
				effect: 'fade',
				speed: 1,
				loop: true,
				keyboard: true,
				hashNavigation: {
					watchState: true,
				},
				navigation: {
					prevEl: '.main_prev',
					nextEl: '.main_next',
				},
			});
		});
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
